import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { AuthAdminContextProvider } from './context/AdminAuthContext'
import { AuthContextProvider } from './context/AuthContext'
import { CurrencyContextProvider } from './context/CurrencyContext'
import { getOrCreateDeviceId } from './utils/deviceId'

getOrCreateDeviceId()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <AuthAdminContextProvider>
    <AuthContextProvider>
      <CurrencyContextProvider>
        <React.StrictMode>
          <HelmetProvider>
            <BrowserRouter>
              <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}>
                <App />
              </GoogleReCaptchaProvider>
            </BrowserRouter>
          </HelmetProvider>
        </React.StrictMode>
      </CurrencyContextProvider>
    </AuthContextProvider>
  </AuthAdminContextProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
